<template>
    <v-container class="d-flex justify-center align-center fill-height">
        <v-card class="pa-12" rounded :outlined="$vuetify.breakpoint.mobile ? false : true"
                :elevation="$vuetify.breakpoint.mobile ? 0 : 24"
                :loading="progress" max-width="1024">
            <template slot="progress">
                <v-progress-circular class="loading" color="primary" size="200" width="1" indeterminate></v-progress-circular>
            </template>
            <v-card-title class="d-flex justify-center text-h4 mb-16">Help</v-card-title>
            <v-card-text>
                <p class="text-body-1 font-weight-light">
                    Found a problem with the site, have a question, idea, comment, concern, or have another issue you'd like help with...
                </p>
                <p class="text-body-1 font-weight-light mb-16">
                    Use this form or send an email to <a target="_blank" ref="noopener" href="mailto://support@branfts.com">support@branfts.com</a>
                </p>
                <v-form ref="form" v-model="valid">
                    <v-row>
                        <v-col :class="$vuetify.breakpoint.mobile ? 'pb-0' : ''" :cols="$vuetify.breakpoint.mobile ? 12 : 6">
                            <v-text-field :rules="rules.email" name="input-email" label="Email" v-model="email[0]"></v-text-field>
                        </v-col>
                        <v-col :class="$vuetify.breakpoint.mobile ? 'py-0' : ''" :cols="$vuetify.breakpoint.mobile ? 12 : 6">
                            <v-text-field :rules="rules.email2" name="input-email-confirm" label="Confirm Email" v-model="email[1]"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col :class="$vuetify.breakpoint.mobile ? 'py-0' : ''">
                            <v-text-field hint="What do you need help with?" :rules="rules.subject" name="input-subject" label="Subject" v-model="subject"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col :class="$vuetify.breakpoint.mobile ? 'pt-0' : ''">
                            <v-textarea hint="Please add as much detail as possible to receive the best help possible." counter :rules="rules.message" name="input-message" outlined label="Message" v-model="message"></v-textarea>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-alert type="success" :value="alert['success']">Thank you. Your support issue has been sent.</v-alert>
            <v-snackbar color="error" :value="alert['error']">{{ this.alert['error'] }}</v-snackbar>
            <v-card-actions class="justify-center">
                <v-btn color="primary"
                       :disabled="this.submitted"
                       @click="submit">
                    Submit
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>
<style>
.loading {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -100px;
    margin-left: -100px;
    z-index: 1;
}
</style>
<script>
export default {
    name: "Support",
    components: {},
    props: {},
    data: function () {
        return {
            email: [],
            subject: null,
            message: "",
            rules: {
                email: [
                    (v) =>
                        !!(v || "").match(/@/) || "Please enter a valid email",
                ],
                email2: [
                    (v) =>
                        !!(v || "").match(/@/) || "Please enter a valid email",
                    (v) =>
                        (v && v === this.email[0]) ||
                        "Email addresses do not match.",
                ],
                subject: [
                    (v) => (v && v.length <= 100) || "Max 100 characters",
                ],
                message: [
                    (v) => (v && v.length <= 1000) || "Max 1000 characters",
                ],
            },
            loading: false,
            response: null,
            progress: false,
            alert: {
                error: false,
                success: false,
            },
            submitted: false,
            valid: false,
        };
    },
    methods: {
        errorAlert(error) {
            this.alert["error"] = error.message;
            setTimeout(() => {
                this.alert["error"] = false;
            }, 10000);
        },
        submit() {
            if (!this.$refs.form.validate()) return;
            this.loading = true;
            this.$backend
                .openSupportIssue({
                    email: this.email[0],
                    subject: this.subject,
                    message: this.message,
                })
                .then((response) => {
                    this.response = response;
                    setTimeout(() => {
                        this.loading = false;
                        this.alert["success"] = true;
                        this.submitted = true;
                    }, 3000);
                })
                .catch((error) => {
                    console.log(error);
                    this.alert["error"] = error;
                    this.loading = false;
                });
        },
    },
    computed: {},
    mounted() {},
};
</script>
